export default __webpack_public_path__ + "static/media/portrait-right.f484f353.svg";